export default (data, andNull) =>
  Object.keys(data).forEach(
    // eslint-disable-next-line no-param-reassign
    key => (data[key] === undefined || (andNull ? data[key] === null : false)) && delete data[key]
  )
